
import { useState, useEffect } from 'react';

export const useTechniquesPerPage = (defaultValue: number = 9, storageKey: string = 'techniquesPerPage') => {
  const [itemsPerPage, setItemsPerPage] = useState<number>(defaultValue);
  
  // Load itemsPerPage from localStorage on mount
  useEffect(() => {
    const savedItemsPerPage = localStorage.getItem(storageKey);
    if (savedItemsPerPage) {
      setItemsPerPage(parseInt(savedItemsPerPage, 10));
    }
  }, [storageKey]);
  
  // Store itemsPerPage in localStorage when it changes
  const handleItemsPerPageChange = (value: number) => {
    setItemsPerPage(value);
    localStorage.setItem(storageKey, String(value));
  };
  
  return { itemsPerPage, setItemsPerPage: handleItemsPerPageChange };
};
